var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68421 0H12.3158C15.4551 0 18 2.54491 18 5.68421V12.3158C18 15.4551 15.4551 18 12.3158 18H5.68421C2.54491 18 0 15.4551 0 12.3158V5.68421C0 2.54491 2.54491 0 5.68421 0ZM12.3158 16.5789C14.6681 16.5737 16.5737 14.6681 16.5789 12.3158V5.68421C16.5737 3.33189 14.6681 1.42626 12.3158 1.42105H5.68421C3.33189 1.42626 1.42626 3.33189 1.42105 5.68421V12.3158C1.42626 14.6681 3.33189 16.5737 5.68421 16.5789H12.3158Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0126 4.26316C11.6224 4.26826 11.3072 4.5834 11.3021 4.97368C11.2922 5.57172 11.0431 6.14087 10.6105 6.5539C10.1779 6.96693 9.59785 7.1894 9 7.17158C7.76858 7.20881 6.73909 6.24287 6.69789 5.01158C6.69789 4.61917 6.37978 4.30105 5.98737 4.30105C5.59496 4.30105 5.27684 4.61917 5.27684 5.01158C5.31829 7.02761 6.98388 8.62963 9 8.59263C11.0161 8.62963 12.6817 7.02761 12.7232 5.01158C12.7336 4.81666 12.6633 4.62604 12.5289 4.48448C12.3945 4.34292 12.2078 4.26288 12.0126 4.26316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.1c28e2a4351ccc8b51932f147eda4fcc.svg";
export { ForwardRef as ReactComponent };